import { useEffect, useRef } from "react"
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'
import { useDispatch, useSelector } from "react-redux";
import axios from "axios"
import sockets from "../../../../socket/socket";

const socket = sockets;

export default function GlobalNotify({ item }) {

    const getDarkModoe = useSelector(darkModes => darkModes);
    const innerRef = useRef(null)
    useEffect(() => {
        var stringWithoutQuotes = item.notifyText.replace(/'/g, '');
        innerRef.current.innerHTML = stringWithoutQuotes;

    }, [item])


    const handleDelete = (e) => {



        axios.post("/handleDelete/api", {
            itemID: item._id,
        })
            .then(function (response) {

                socket.emit("getNotifyEmit");

            })
            .catch(function (error) {
                console.log(error);

            });
    };

    function changeDateToCurrent() {
        let date = item.endDate.split("T");
        let changeDateToCurrent = new Date(date)

        let mount = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]
        let changetDate = changeDateToCurrent.getDate() + " " + mount[changeDateToCurrent.getMonth()] + " " + changeDateToCurrent.getFullYear()
        return changetDate
    }
    if (item.recipientInfo) {
        
    }
    return (
        <>
            <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "notifyContDark" : "notifyCont"}>
                <div className="myifnoCont">
                    <Avatar size='2xl' src={item.recipientInfo.img ? item.recipientInfo.img : 'https://bit.ly/broken-link'} />

                    <div className="myifno">
                        <p className="myname">{item.recipientInfo.name}</p>
                        <label htmlFor="" style={{ marginTop: "15px" }} >Телефон</label>
                        <input type="text" value={item.directorInfo.tel} disabled />
                        <label htmlFor="">Почта</label>
                        <input type="text" value={item.directorInfo.email} placeholder="NadyaIsaev@gmail.com" disabled />
                    </div>
                </div>
                <div className="taskInfoCont">
                    <div>

                        {
                            JSON.parse(item.isChild) ?
                                <a href={`editChild/${item.eidtTaskID}/${item.indexTask}`} target="_blank" className="taskName">Проект#{item.taskName}</a>
                                :
                                <a href={`getCurrentTask/${item.eidtTaskID}`} target="_blank" className="taskName">Проект#{item.taskName}</a>
                        }

                        <p className="taskDate">{item.date}</p>
                    </div>
                    <div className="tasotherinfo">
                        <div>
                            <p ref={innerRef}></p>
                        </div>


                        <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none" onClick={handleDelete}>
                            <g filter="url(#filter0_d_694_3875)">
                                <circle cx="27" cy="25" r="24" fill="#42FF00" />
                            </g>
                            <rect x="15.4277" y="21.6934" width="16.9014" height="4.73239" transform="rotate(45 15.4277 21.6934)" fill="white" />
                            <path d="M42.4062 18.6162L24.0326 36.9898L20.6862 33.6435L39.0599 15.2699L42.4062 18.6162Z" fill="white" />
                            <defs>
                                <filter id="filter0_d_694_3875" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="2" />
                                    <feGaussianBlur stdDeviation="1.5" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_694_3875" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_694_3875" result="shape" />
                                </filter>
                            </defs>
                        </svg>

                    </div>

                </div>



            </div>

        </>
    )
}